import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_SIGNER_VELOCITY = defineFcm('petition_page_signer_velocity')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Page',
		description:
			'Runtime kill switch for the petition_page_signer_velocity_experiment. When disabled the ' +
			'experiment resolves to control with fallbackReason "disabled" and the recency pill never renders. ' +
			'The daily ignition floor is NOT configurable here — it is the DEFAULT_DAILY_SIGNATURE_FLOOR ' +
			'constant in useSignerVelocityExperiment, so changing it takes a code change and a deploy.',
		import: false,
		// `enabled: true`, not false. `withDefault({ enabled: false })` already protects production before the
		// config exists, so creating it in the admin is the deliberate act of turning the experiment on. A
		// template pre-filled `false` makes that a silent no-op — the operator reports the experiment live
		// while every session resolves `fallbackReason: 'disabled'`.
		template: { enabled: true },
		deprecated: 'FCM no longer in use — safe to delete after 2026-09-08',
	});
